import { EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

export abstract class EditSectionComponent<T> {
    // set by navigation service to let component know that the form
    // was submitted via advancing in purchase path
    public submitted: boolean = false;

    // Triggered whenever changes are made in the commponent or it's children
    public valueChanges: EventEmitter<T> = new EventEmitter<T>();

    // prevent navigation from moving forward for things like
    // invalid data, callout in progress, etc.
    public abstract canContinue(isQuickQuote: boolean): Observable<boolean>;

    // write values to the purchase path data so they can be stored
    // in session storage
    public abstract writeValues(data: T): void;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy-edit/edit-section.component.ts